import { Grid2, Typography } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useBatteryInfo, useVehicleInfo } from "../../../../Pages/DigitalTwinV3/DigitalTwinContext";
import { DigitalTwinTabContainer } from "../../../../Theme/DigitalTwinStyles";
import TwinHierarchyCard from "../BatteryVitals/TwinHierarchyCard";
import VitalsChartSection from "../BatteryVitals/VitalsChartSection";
import { fetchDigitalTwinHierarchy } from "../../../../Helper/DigitalTwin/DigitalTwinFunctions";

export default function VehicleVitals() {
    const { batteryID, batteryInfo } = useBatteryInfo();

    const { t } = useTranslation(['common', 'digital_twin']);
    const [selectedNode, setSelectedNode] = React.useState(null);
    const vehicleInfo = useVehicleInfo();
    const [digitalTwinHierarchy, setDigitalTwinHierarchy] = React.useState([]);

    const prepareDigitalTwinHierarchy = async () => {
        const entityTypes = ['VEHICLE_SYSTEM']
        const digitalTwinHierarchyResponse = await fetchDigitalTwinHierarchy(batteryID, entityTypes, t);
        setDigitalTwinHierarchy(digitalTwinHierarchyResponse);
    }

    React.useEffect(() => {
        prepareDigitalTwinHierarchy();
    }, []);

    return (
        <DigitalTwinTabContainer gap="16px">
            <Grid2 container flexDirection="column" gap="4px" paddingTop={'4px'} paddingBottom={'20px'} paddingLeft={'12px'}>
                <Typography variant="fw500s16lh20c000000"> {t(`digital_twin:vehicle_tab.compare_vitals_title`)} </Typography>
                <Typography variant="fw400s12c686868">{t(`digital_twin:vehicle_tab.compare_vitals_subtitle`)}</Typography>
            </Grid2>

            <Grid2 container sx={{
                borderRadius: '14px',
                border: '1px solid #E6E6E6',
                backgroundColor: '#FFF',
                minHeight: '500px',
                flexWrap: 'nowrap',
                mb: 10
            }}>
                <Grid2 sx={{ width: '20%', flexShrink: 0, borderRight: '1px solid #E6E6E6' }}>
                    <TwinHierarchyCard
                        title="Vehicle System"
                        tab="vehicleVitals"
                        currentNode={selectedNode}
                        onChangeNode={(node) => setSelectedNode(node)}
                        digitalTwinHierarchy={digitalTwinHierarchy}
                    />
                </Grid2>

                {selectedNode && (
                    <Grid2 flexGrow={1}>
                        <VitalsChartSection
                            selectedNode={selectedNode}
                            batteryID={batteryID}
                            batteryInfo={batteryInfo}
                            vehicleInfo={vehicleInfo}
                            vitalsSection="vehicleVitals"
                        />
                    </Grid2>
                )}
            </Grid2>
        </DigitalTwinTabContainer>
    )
}
